/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddSavedContactRequest,
  AddSavedLocationRequest,
  DeleteAddressBookEntryRequest,
  GetAllSavedLocationsResponse,
  GetBranchesResponse,
  ModifySavedContactRequest,
  ModifySavedLocationRequest,
  SavedLocation,
  SetDefaultContactRequest,
} from '../models/index';
import {
    AddSavedContactRequestFromJSON,
    AddSavedContactRequestToJSON,
    AddSavedLocationRequestFromJSON,
    AddSavedLocationRequestToJSON,
    DeleteAddressBookEntryRequestFromJSON,
    DeleteAddressBookEntryRequestToJSON,
    GetAllSavedLocationsResponseFromJSON,
    GetAllSavedLocationsResponseToJSON,
    GetBranchesResponseFromJSON,
    GetBranchesResponseToJSON,
    ModifySavedContactRequestFromJSON,
    ModifySavedContactRequestToJSON,
    ModifySavedLocationRequestFromJSON,
    ModifySavedLocationRequestToJSON,
    SavedLocationFromJSON,
    SavedLocationToJSON,
    SetDefaultContactRequestFromJSON,
    SetDefaultContactRequestToJSON,
} from '../models/index';

export interface AddDefaultContactRequest {
    addSavedContactRequest?: AddSavedContactRequest;
}

export interface AddSavedContactOperationRequest {
    addSavedContactRequest?: AddSavedContactRequest;
}

export interface AddSavedLocationOperationRequest {
    addSavedLocationRequest?: AddSavedLocationRequest;
}

export interface DeleteSavedContactRequest {
    savedContactId: string;
}

export interface DeleteSavedLocationRequest {
    deleteAddressBookEntryRequest?: DeleteAddressBookEntryRequest;
}

export interface GetOneSavedLocationRequest {
    savedLocationId: string;
}

export interface ModifySavedContactOperationRequest {
    modifySavedContactRequest?: ModifySavedContactRequest;
}

export interface ModifySavedLocationOperationRequest {
    modifySavedLocationRequest?: ModifySavedLocationRequest;
}

export interface SetDefaultContactOperationRequest {
    setDefaultContactRequest?: SetDefaultContactRequest;
}

export interface ToggleBranchRequest {
    savedLocationId: string;
}

export interface ToggleDefaultDeliveryLocationRequest {
    savedLocationId: string;
}

export interface ToggleDefaultPickupLocationRequest {
    savedLocationId: string;
}

export interface ToggleFavouriteRequest {
    savedLocationId: string;
}

/**
 * 
 */
export class SavedLocationsApi extends runtime.BaseAPI {

    /**
     * 
     */
    async addDefaultContactRaw(requestParameters: AddDefaultContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/add-default-contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddSavedContactRequestToJSON(requestParameters['addSavedContactRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async addDefaultContact(requestParameters: AddDefaultContactRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addDefaultContactRaw(requestParameters, initOverrides);
    }

    /**
     * Add a new contact
     */
    async addSavedContactRaw(requestParameters: AddSavedContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/add-contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddSavedContactRequestToJSON(requestParameters['addSavedContactRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add a new contact
     */
    async addSavedContact(requestParameters: AddSavedContactOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addSavedContactRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async addSavedLocationRaw(requestParameters: AddSavedLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddSavedLocationRequestToJSON(requestParameters['addSavedLocationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async addSavedLocation(requestParameters: AddSavedLocationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addSavedLocationRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * Your GET endpoint
     */
    async deleteSavedContactRaw(requestParameters: DeleteSavedContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['savedContactId'] == null) {
            throw new runtime.RequiredError(
                'savedContactId',
                'Required parameter "savedContactId" was null or undefined when calling deleteSavedContact().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['savedContactId'] != null) {
            queryParameters['savedContactId'] = requestParameters['savedContactId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/delete-contact`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Your GET endpoint
     */
    async deleteSavedContact(requestParameters: DeleteSavedContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSavedContactRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async deleteSavedLocationRaw(requestParameters: DeleteSavedLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteAddressBookEntryRequestToJSON(requestParameters['deleteAddressBookEntryRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async deleteSavedLocation(requestParameters: DeleteSavedLocationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSavedLocationRaw(requestParameters, initOverrides);
    }

    /**
     * Your GET endpoint
     */
    async getAllSavedLocationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllSavedLocationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllSavedLocationsResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getAllSavedLocations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllSavedLocationsResponse> {
        const response = await this.getAllSavedLocationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getBranchesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBranchesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/branches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBranchesResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getBranches(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBranchesResponse> {
        const response = await this.getBranchesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getOneSavedLocationRaw(requestParameters: GetOneSavedLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SavedLocation>> {
        if (requestParameters['savedLocationId'] == null) {
            throw new runtime.RequiredError(
                'savedLocationId',
                'Required parameter "savedLocationId" was null or undefined when calling getOneSavedLocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['savedLocationId'] != null) {
            queryParameters['savedLocationId'] = requestParameters['savedLocationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/get-one`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SavedLocationFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getOneSavedLocation(requestParameters: GetOneSavedLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SavedLocation> {
        const response = await this.getOneSavedLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async modifySavedContactRaw(requestParameters: ModifySavedContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/modify-contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ModifySavedContactRequestToJSON(requestParameters['modifySavedContactRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async modifySavedContact(requestParameters: ModifySavedContactOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.modifySavedContactRaw(requestParameters, initOverrides);
    }

    /**
     * savedLocations
     */
    async modifySavedLocationRaw(requestParameters: ModifySavedLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/modify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ModifySavedLocationRequestToJSON(requestParameters['modifySavedLocationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * savedLocations
     */
    async modifySavedLocation(requestParameters: ModifySavedLocationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.modifySavedLocationRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async setDefaultContactRaw(requestParameters: SetDefaultContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/set-default-contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetDefaultContactRequestToJSON(requestParameters['setDefaultContactRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async setDefaultContact(requestParameters: SetDefaultContactOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setDefaultContactRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async toggleBranchRaw(requestParameters: ToggleBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['savedLocationId'] == null) {
            throw new runtime.RequiredError(
                'savedLocationId',
                'Required parameter "savedLocationId" was null or undefined when calling toggleBranch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['savedLocationId'] != null) {
            queryParameters['savedLocationId'] = requestParameters['savedLocationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/toggle-branch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async toggleBranch(requestParameters: ToggleBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.toggleBranchRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async toggleDefaultDeliveryLocationRaw(requestParameters: ToggleDefaultDeliveryLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['savedLocationId'] == null) {
            throw new runtime.RequiredError(
                'savedLocationId',
                'Required parameter "savedLocationId" was null or undefined when calling toggleDefaultDeliveryLocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['savedLocationId'] != null) {
            queryParameters['savedLocationId'] = requestParameters['savedLocationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/toggle-default-delivery-location`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async toggleDefaultDeliveryLocation(requestParameters: ToggleDefaultDeliveryLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.toggleDefaultDeliveryLocationRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async toggleDefaultPickupLocationRaw(requestParameters: ToggleDefaultPickupLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['savedLocationId'] == null) {
            throw new runtime.RequiredError(
                'savedLocationId',
                'Required parameter "savedLocationId" was null or undefined when calling toggleDefaultPickupLocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['savedLocationId'] != null) {
            queryParameters['savedLocationId'] = requestParameters['savedLocationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/toggle-default-pickup-location`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async toggleDefaultPickupLocation(requestParameters: ToggleDefaultPickupLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.toggleDefaultPickupLocationRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async toggleFavouriteRaw(requestParameters: ToggleFavouriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['savedLocationId'] == null) {
            throw new runtime.RequiredError(
                'savedLocationId',
                'Required parameter "savedLocationId" was null or undefined when calling toggleFavourite().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['savedLocationId'] != null) {
            queryParameters['savedLocationId'] = requestParameters['savedLocationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/saved-locations/toggle-favourite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async toggleFavourite(requestParameters: ToggleFavouriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.toggleFavouriteRaw(requestParameters, initOverrides);
    }

}
